














































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import StepForm from './StepForm.vue'
import { requiredRule } from '@/helpers/validation'
import range from '@/helpers/range'
import months from '@/helpers/months'
import axios from 'axios'

type StepData = {
  month: number | null
  year: number | null
  caseCount: number | null
}

type SurveyData = {
  step1: StepData
  step2: StepData
  step3: StepData
  plannedMonth: number | null
  plannedYear: number | null
  knownMisuse: boolean
  freeBrochureCount: null | 1 | 2 | 3
  paidBrochureCount: null | number
  shippingAddress: Address
  billingAddress: Address
  billingAddressEqualsShippingAddress: boolean
  email: string
  originalEmail: string
}

type Address = {
  name1: string
  name2: string
  zip: string
  street: string
  city: string
}

const baseUrl = process.env.VUE_APP_API_BASE_URL

const toFormValue = (value: string | number | null) => {
  if (value) {
    return String(value)
  } else {
    return ''
  }
}

const toDateValue = (
  key: string,
  month: number | null,
  year: number | null
) => {
  const dateValue: Record<string, string> = {}
  if (year && month) {
    dateValue[`${key}_day`] = '1'
    dateValue[`${key}_month`] = String(month)
    dateValue[`${key}_year`] = String(year)
  } else if (year) {
    dateValue[`${key}_day`] = '1'
    dateValue[`${key}_month`] = '1'
    dateValue[`${key}_year`] = String(year)
  } else {
    dateValue[`${key}_day`] = ''
    dateValue[`${key}_month`] = ''
    dateValue[`${key}_year`] = ''
  }
  return dateValue
}

@Component({
  components: {
    StepForm
  }
})
export default class Survey extends Vue {
  @Prop(Number) step!: number
  @Prop(String) token!: string | undefined
  valid = false
  loading = false
  readonly months = months

  surveyData: SurveyData = {
    step1: {
      month: null,
      year: null,
      caseCount: null
    },
    step2: {
      month: null,
      year: null,
      caseCount: null
    },
    step3: {
      month: null,
      year: null,
      caseCount: null
    },
    plannedMonth: null,
    plannedYear: null,
    knownMisuse: false,
    freeBrochureCount: null,
    paidBrochureCount: null,
    email: '',
    originalEmail: '',
    shippingAddress: {
      name1: '',
      name2: '',
      zip: '',
      street: '',
      city: ''
    },
    billingAddressEqualsShippingAddress: true,
    billingAddress: {
      name1: '',
      name2: '',
      zip: '',
      street: '',
      city: ''
    }
  }

  mounted() {
    if (this.token) {
      this.getEmail().then(({ email: email }: { email: string }) => {
        this.surveyData.email = email
        this.surveyData.originalEmail = email
      })
    }
  }

  async getEmail() {
    const url = `${baseUrl}/?token=${this.token}`
    const response = await axios({
      url,
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
    return await response.data
  }

  get plannedYears() {
    return range(2020, 2025)
  }

  get paidBrochureCountRange() {
    return [...range(1, 5), 10, 20, 30, 50]
  }

  get plannedDateEmpty() {
    return !this.surveyData.plannedYear && !this.surveyData.plannedMonth
  }

  get requiredRules() {
    return [requiredRule]
  }

  get needsShippingAddress() {
    return (
      this.surveyData.freeBrochureCount && this.surveyData.freeBrochureCount > 0
    )
  }

  get needsBillingAddress() {
    return (
      this.surveyData.paidBrochureCount && this.surveyData.paidBrochureCount > 0
    )
  }

  updateSurveyData(stepKey: 'step1' | 'step2' | 'step3', stepData: StepData) {
    const newData: Record<string, StepData> = {}
    newData[stepKey] = { ...this.surveyData[stepKey], ...stepData }
    this.surveyData = { ...this.surveyData, ...newData }
  }

  nextStep() {
    this.$router.push({
      query: { ...this.$route.query, step: String(this.currentStep + 1) }
    })
  }

  previousStep() {
    this.$router.push({
      query: { ...this.$route.query, step: String(this.currentStep - 1) }
    })
  }

  get currentStep() {
    return this.step
  }
  set currentStep(value) {
    this.$router.push({ query: { ...this.$route.query, step: String(value) } })
  }

  submit() {
    this.loading = true
    this.postSurveyData().finally(() => {
      this.loading = false
      this.$router.push({ name: 'Confirmation' })
    })
  }

  async postSurveyData() {
    const url =
      'https://docs.google.com/forms/u/3/d/e/1FAIpQLSfVxF98jlS9vrou2BaC0RRSgF7WGzoS5fn_-eeQb9h7XoBXDQ/formResponse'
    return axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: this.formData,
      url
    })
  }

  get formData() {
    let data: Record<string, string> = {
      'entry.1777994340': toFormValue(this.surveyData.step1.caseCount),
      'entry.1815508267': toFormValue(this.surveyData.step2.caseCount),
      'entry.466434988': toFormValue(this.surveyData.step3.caseCount),
      'entry.348643029': this.surveyData.knownMisuse ? 'Ja' : 'Nein',
      'entry.2068793175': toFormValue(this.surveyData.freeBrochureCount),
      'entry.1204365017': toFormValue(this.surveyData.paidBrochureCount),
      'entry.776439660': toFormValue(this.surveyData.email),
      'entry.1812052009': toFormValue(this.surveyData.originalEmail),
      'entry.224689705': toFormValue(this.surveyData.shippingAddress.name1),
      'entry.476612961': toFormValue(this.surveyData.shippingAddress.name2),
      'entry.162535574': toFormValue(this.surveyData.shippingAddress.street),
      'entry.1083154960': toFormValue(this.surveyData.shippingAddress.zip),
      'entry.2084359167': toFormValue(this.surveyData.shippingAddress.city),
      'entry.1065478056': toFormValue(this.surveyData.billingAddress.name1),
      'entry.392404027': toFormValue(this.surveyData.billingAddress.name2),
      'entry.206404572': toFormValue(this.surveyData.billingAddress.street),
      'entry.744789827': toFormValue(this.surveyData.billingAddress.zip),
      'entry.1928768716': toFormValue(this.surveyData.billingAddress.city)
    }

    data = {
      ...data,
      ...toDateValue(
        'entry.1748688631',
        this.surveyData.step1.month,
        this.surveyData.step1.year
      ),
      ...toDateValue(
        'entry.494657378',
        this.surveyData.step2.month,
        this.surveyData.step2.year
      ),
      ...toDateValue(
        'entry.131740981',
        this.surveyData.step3.month,
        this.surveyData.step3.year
      ),
      ...toDateValue(
        'entry.1559702946',
        this.surveyData.plannedMonth,
        this.surveyData.plannedYear
      )
    }

    return Object.keys(data)
      .map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      })
      .join('&')
  }
}
